import { PurchaseService } from './../../services/purchase.service';
import { ResellerRegisterModel } from './../../models/resellerRegisterModel';
import { Login, UserLoaded } from './../../../../../core/auth/_actions/auth.actions';
import { User } from './../../../../../core/auth/_models/user.model';
import { AuthService } from './../../../../../core/auth/_services/auth.service';
import { CommonService } from './../../../shared/services/common.service';
import { AccountService } from './../../../account/services/account.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { currentUser, isLoggedIn } from './../../../../../core/auth/_selectors/auth.selectors';
import { AppState } from './../../../../../core/reducers/index';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, Inject } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Router } from '@angular/router';
import { SharedObject } from '../../../shared/sharedObject';
import { ConfirmPasswordValidator } from '../../../shared/validators/confirm-password.validator';
import { MatDialog, MatStepper } from '@angular/material';
import { DialogBoxComponent } from '../../../shared/dialog/dialog-box/dialog-box.component';
import { RoleService } from '../../../shared/services/roleService';
import { ProfileDocumentModel } from '../../../account/models/profile/ProfileDocumentModel';
import { ContactInfoModel } from '../../../shared/models/contactInfoModel';
import { catchError, finalize, first, tap } from 'rxjs/operators';
import { BehaviorSubject, of } from 'rxjs';
import { ResellerInfoModel } from '../../../account/models/profile/reellerInfoModel';
import { UserProfileModel } from '../../../account/models/userProfileModel';
import { DirectoriesService } from '../../../shared/services/directories.service';
import { SellerInfoFormCompComponent } from './seller-info-form-comp/seller-info-form-comp.component';
import { ResellerUpdateModel } from '../../../account/models/profile/resellerUpdateModel';
import { TheftIpDataTableDataSource } from '../../../account/Pages/my-devices/theft-details/data-table-theft-details';
import { A } from '@angular/cdk/keycodes';
import { RegisterUserModel } from '../../../../../core/auth/_models/registerUserModel';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-reseller-signup',
  templateUrl: './reseller-signup.component.html',
  styleUrls: ['./reseller-signup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResellerSignupComponent implements OnInit {
  registrationForm: FormGroup;
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('resellerComp') resellerComp: SellerInfoFormCompComponent;
  emailInvalidError: string = null;
  loginError: string = null;


  loading: boolean = false;
  contactInfoModel: ContactInfoModel = new ContactInfoModel();
  newUserRegistered: boolean = false;
  userRegisterState = 0;
  user: User | null = null;
  sellerInfo: ResellerInfoModel | null = null;
  userProfile: UserProfileModel | null = null;
  private _mobile = new BehaviorSubject<boolean>(false)
  mobile$ = this._mobile.asObservable()
  //0 unnown
  //1 logined
  //2 exist user and not login
  //3 new user
  //4 new user or exist user logined
  constructor(private store: Store<AppState>,
    private router: Router,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private auth: AuthService,
    private roleService: RoleService,
    private commonService: CommonService,
    private accountService: AccountService,
    private breakpointObserver: BreakpointObserver,
    private directoriesService: DirectoriesService
  ) {

    this.breakpointObserver.observe([
      Breakpoints.Handset,
      Breakpoints.HandsetPortrait,
      Breakpoints.HandsetLandscape
    ]).pipe(
      first()
    ).subscribe(result => {
      this._mobile.next(result.matches)
    })

    this.store
      .pipe(
        select(isLoggedIn),
        tap(loggedIn => {
          if (loggedIn) {
            if (this.userRegisterState == 0) {
              this.userRegisterState = 1;
            }

            // this.store.pipe(select(currentUser))
            //   .toPromise()
            //   .then((res: User) => {
            //     this.user = res;
            //   });
          }
        })
      ).subscribe();
  }

  async ngOnInit() {

    this.registrationForm = new FormGroup({
      'phoneNumberForm': new FormGroup({
        'phoneNumber': new FormControl(null, Validators.compose([
          Validators.required,
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.pattern(SharedObject.MobilePattern)
        ]))
      }),
      'registerForm': new FormGroup({
        'fName': new FormControl(null, Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
          Validators.pattern(SharedObject.FarsiPattern)
        ])),
        'lName': new FormControl(null, Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(SharedObject.FarsiPattern)
        ])),
        'gender': new FormControl(null, Validators.required),
        'birthday': new FormControl(new Date(), Validators.compose([
          Validators.required
        ])),
        'password': new FormControl(null, Validators.compose([
          Validators.required,
          Validators.pattern(SharedObject.PasswordPattern)
        ])),
        'confirmPassword': new FormControl(null, Validators.compose([
          Validators.required,
          Validators.pattern(SharedObject.PasswordPattern)
        ])),
      }, {
        validators: ConfirmPasswordValidator.MatchPassword
      }),
      'userInfoForm': new FormGroup({
        'fName': new FormControl(null, Validators.compose([
          Validators.required,
          Validators.pattern(SharedObject.FarsiPattern)
        ])),
        'lName': new FormControl(null, Validators.compose([
          Validators.required,
          Validators.pattern(SharedObject.FarsiPattern)
        ])),
        'gender': new FormControl(null, Validators.required),
        'birthday': new FormControl(null, Validators.compose([
          Validators.required
        ])),
      }),
      'sellerInfoForm': new FormGroup({
        'shopName': new FormControl(null, Validators.required),
        'zipCode': new FormControl(null, Validators.compose([
          Validators.required,
          Validators.pattern("[0-9]{10}")
        ])),
        'url': new FormControl(null, Validators.compose([
          Validators.pattern(SharedObject.WebUrlPattern)
        ])),
        'address': new FormControl(null, Validators.required),
        'email': new FormControl(null, Validators.compose([
          Validators.required,
          Validators.pattern(SharedObject.EmailPattern)
        ])),
        'resellerType': new FormControl(null, Validators.required),
        'provinceId': new FormControl(null, Validators.required),
        'directoryId': new FormControl(null, Validators.required),
      }),
      'loginPasswordForm': new FormGroup({
        'password': new FormControl(null, Validators.compose([
          Validators.required,
          Validators.pattern(SharedObject.PasswordPattern)
        ]))
      }),
      'documentForm': new FormGroup({}),
    });
    if (this.userRegisterState == 1) {
      this.loading = true;
      await this.getUserProfile();
      this.loading = false;
    } else {

    }
  }

  isControlHasError(controlName: string, validationType: string, form: string): boolean {
    const control = this.registrationForm.get(form).get(controlName);
    if (!control) {
      return false;
    }
    const result = control.hasError(validationType);
    this.cdr.markForCheck();
    return result;

  }

  nextFirst() {
    if (this.stepper.selectedIndex > 0) return;
    const controls = this.registrationForm.controls['phoneNumberForm']['controls'];
    /** check form */
    if (this.registrationForm.get('phoneNumberForm').invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.loading = true;
    this.commonService.checkPhoneNumber(this.registrationForm.get('phoneNumberForm').get('phoneNumber').value).
      subscribe((res: boolean) => {
        //شماره از قبل وجود دارد
        if (res) {
          this.userRegisterState = 2;
          this.loading = false;
          this.cdr.markForCheck();
        } else { //کاربر جدید است
          this.userRegisterState = 3;
          const dialogRef = this.dialog.open(DialogBoxComponent, {
            width: '550px',
            data: { title: "مطمئن هستید؟", message: "شماره موبایل وارد شده حکم نام کاربری شما را دارد. آیا از صحیح بودن آن اطمینان دارید؟", dialogType: "YesNo", useColorButton: true }
          });
          dialogRef.afterClosed().subscribe(result => {

            if (result == null || result != "yes") {
              this.loading = false;
              this.cdr.markForCheck();
              return;
            }
            this.stepperGo(1);
            this.cdr.markForCheck();
          });
        }
      });
  }

  resellerNextClick() {

    const controls = this.registrationForm.controls['sellerInfoForm']['controls'];
    /** check form */
    if (this.registrationForm.get('sellerInfoForm').invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.loading = true;
    this.cdr.markForCheck();
    this.commonService.isValidEmail(this.registrationForm.get('sellerInfoForm').get('email').value).subscribe((res: boolean) => {
      if (res) {
        this.stepper.next();
      }
      else {
        //this.stepper.next(); //temp
        this.emailInvalidError = 'ایمیل مورد نظر قبلا در سیستم ثبت شده است';
        this.loading = false;
        this.cdr.markForCheck();
        return;
      }
    }, err => {
      this.loading = false;
      this.emailInvalidError = err.error['statusCode'];
      this.cdr.markForCheck();
    });
  }

  stepperSelectionChange() {
    this.loading = false;
    this.cdr.markForCheck();
  }


  nextFoure() {
    if (this.userRegisterState == 2) {
      const controls = this.registrationForm.controls['loginPasswordForm']['controls'];
      /** check form */
      if (this.registrationForm.get('loginPasswordForm').invalid) {
        Object.keys(controls).forEach(controlName =>
          controls[controlName].markAsTouched()
        );
        return;
      }
      this.loginUser(true);
    }
    else if (this.userRegisterState == 3) {
      const controls = this.registrationForm.controls['passwordForm']['controls'];
      /** check form */
      if (this.registrationForm.get('passwordForm').invalid) {
        Object.keys(controls).forEach(controlName =>
          controls[controlName].markAsTouched()
        );
        return;
      }

      this.stepper.next();
    }
  }

  prevFoure() {
    if (this.userRegisterState == 2) this.stepper.selectedIndex = 0;
    else
      this.stepper.previous();
  }
  async resellerUpdateForwardClick() {
    if (this.userRegisterState == 1) {
      this.stepperGo(2);

    } else if (this.userRegisterState == 2) {
      this.stepperGo(3);
    } else if (this.userRegisterState == 3) {
      this.stepperGo(3);

    } else {
      this.stepperGo(4);
    }
    await this.getUserProfile();
    await this.getResellerInfo();
  }

  resellerUpdateBackClick() {
    this.stepper.previous();
  }





  checkUserStatus() {
    if (!this.sellerInfo) return;

    if (this.userRegisterState == 1) {
      switch (this.sellerInfo.userStatus) {
        case 0:
        case 1:
        case 4:
          this.stepperGo(0);
          break;
        case 2:
          this.stepperGo(1);
        case 3:
          this.stepperGo(2);
          break;
        case 4:
          break;
      }
    } else {

    }


  }

  nationalCardUrl: any = null;
  async getResellerInfo() {
    this.loading = true;
    await this.accountService.getResellerProfile().toPromise().then
      ((res: ResellerInfoModel) => {
        this.sellerInfo = res;
        this.registrationForm.get('sellerInfoForm').get('shopName').setValue(this.sellerInfo.shop);
        this.registrationForm.get('sellerInfoForm').get('zipCode').setValue(this.sellerInfo.zipCode);
        this.registrationForm.get('sellerInfoForm').get('url').setValue(this.sellerInfo.url);
        this.registrationForm.get('sellerInfoForm').get('email').setValue(this.sellerInfo.email);
        this.registrationForm.get('sellerInfoForm').get('address').setValue(this.sellerInfo.address);
        this.registrationForm.get('sellerInfoForm').get('resellerType').setValue(this.sellerInfo.resellerType.toString());

        //گرفتن لیست استان ها
        var provinces = this.directoriesService.getProvinces();
        //گرفتن شهر به همراه استان
        var directory = this.directoriesService.getDirectoryById(this.sellerInfo.directoryId);
        if (directory && directory.ParentId) {
          var parentId = parseInt(directory.ParentId);
          //گرفتن شهرهای استان
          var directories = this.directoriesService.getDirectoriesByParentId(parentId);
          this.registrationForm.get('sellerInfoForm').get('provinceId').setValue(parentId);
          this.resellerComp.provinceChange(parentId);
          this.registrationForm.get('sellerInfoForm').get('directoryId').setValue(this.sellerInfo.directoryId);

          if (this.sellerInfo.nationalCardFile) {
            this.nationalCardUrl = this.commonService.getApiEndpoint() + "/Images/ResellerDocuments/" + this.sellerInfo.nationalCardFile;
          }
          this.checkUserStatus();
        }

        this.loading = false;
        this.cdr.markForCheck();
      });
  }

  async getUserProfile() {
    this.loading = true;
    await this.accountService.getUserProfile()
      .subscribe((res: UserProfileModel) => {
        this.userProfile = res;
        this.registrationForm.get('userInfoForm').get('fName').setValue(res.firstName);
        this.registrationForm.get('userInfoForm').get('lName').setValue(res.lastName);
        this.registrationForm.get('userInfoForm').get('gender').setValue(res.isMale ? 'true' : 'false');
        this.registrationForm.get('userInfoForm').get('birthday').setValue(new Date(res.birthDate));
        this.loading = false;
        this.cdr.markForCheck();
        this.getResellerInfo();
      });
  }


  async userInfoForwardClick() {

    if (this.userRegisterState == 1) {
      const controls = this.registrationForm.controls['userInfoForm']['controls'];
      /** check form */
      if (this.registrationForm.get('userInfoForm').invalid) {
        Object.keys(controls).forEach(controlName =>
          controls[controlName].markAsTouched()
        );
        return;
      }
      //this.userRegisterState=4;
      await this.updateProfile();

      this.stepper.selectedIndex = 1;
      this.stepper.selected;

    } else if (this.userRegisterState == 2 || this.newUserRegistered) {
      const controls = this.registrationForm.controls['userInfoForm']['controls'];
      /** check form */
      if (this.registrationForm.get('userInfoForm').invalid) {
        Object.keys(controls).forEach(controlName =>
          controls[controlName].markAsTouched()
        );
        return;
      }
      await this.updateProfile();
      this.stepperGo(2);


    } else if (this.userRegisterState == 3) {
      const controls = this.registrationForm.controls['registerForm']['controls'];
      /** check form */
      if (this.registrationForm.get('registerForm').invalid) {
        Object.keys(controls).forEach(controlName =>
          controls[controlName].markAsTouched()
        );
        return;
      }
      await this.registerUser();

    }

  }

  private async updateProfile() {
    this.loading = true;
    var model = new UserProfileModel();
    model.firstName = this.registrationForm.get('userInfoForm').get('fName').value;
    model.lastName = this.registrationForm.get('userInfoForm').get('lName').value;
    model.isMale = this.registrationForm.get('userInfoForm').get('gender').value;
    model.birthDate = this.registrationForm.get('userInfoForm').get('birthday').value;
    await this.accountService.saveUserProfile(model).toPromise().then((res: boolean) => {
      this.loading = false;
      this.cdr.markForCheck();
    });
  }

  private loginUser(isNewRegister: boolean = false) {
    this.loading = true;
    const authData = {
      mobile: this.registrationForm.get('phoneNumberForm').get('phoneNumber').value.FaToEnDigits(),
      password: this.registrationForm.get('loginPasswordForm').get('password').value.FaToEnDigits()
    };
    this.auth
      .login(authData.mobile, authData.password)
      .pipe(
        tap(res => {
          if (res) {
            const returnUser: User = new User();
            returnUser.firstName = res["result"]["firstName"];
            returnUser.lastName = res["result"]["lastName"];
            returnUser.isMale = res["result"]["isMale"];
            returnUser.username = res["result"]["username"];
            returnUser.access_token = res["result"]["access_token"];
            returnUser.refresh_token = res["result"]["refresh_token"];
            returnUser.userStatus = res["result"]["userStatus"];
            returnUser.role = res["result"]["role"];
            this.user = returnUser;
            this.store.dispatch(
              new Login({ authToken: returnUser.access_token })
            );
            this.store.dispatch(new UserLoaded({ user: returnUser }));
            this.roleService.getAllRoles();
            this.getUserProfile();
            this.getResellerInfo();

            if (this.userRegisterState == 2) {
              this.stepperGo(1);
            } else if (this.userRegisterState == 3) {
              this.stepperGo(2);
            }

          } else {
            this.loading = false;
            this.loginError = "رمز عبور نادرست است";
          }
        }),
        catchError(err => {
          this.loading = false;
          var error = "خطای سرور";
          if (err.error.result) error = err.error.result;
          this.loginError = error
          this.cdr.detectChanges();
          return of([]);
        }),
        finalize(() => {
          this.cdr.detectChanges();
        })
      )
      .subscribe();
  }



  async registerUser() {
    const controls = this.registrationForm.controls['registerForm']['controls'];
    /** check form */
    if (this.registrationForm.get('registerForm').invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }

    this.loading = true;
    const model: RegisterUserModel = new RegisterUserModel();
    model.userName = this.registrationForm.get('phoneNumberForm').get('phoneNumber').value.FaToEnDigits();
    model.password = this.registrationForm.get('registerForm').get('password').value.FaToEnDigits();
    model.firstName = this.registrationForm.get('registerForm').get('fName').value;;
    model.lastName = this.registrationForm.get('registerForm').get('lName').value;
    model.isMale = this.registrationForm.get('registerForm').get('gender').value;
    model.birthDate = this.registrationForm.get('registerForm').get('birthday').value;
    await this.auth.registerUser(model).subscribe(res => {
      this.registrationForm.get('loginPasswordForm').get('password').setValue(model.password);
      this.newUserRegistered = true;
      this.loginUser(true);
    }, err => {
      this.loading = false;
      this.cdr.markForCheck();
    }, () => {

      this.cdr.markForCheck();
    });
  }

  saveResellerDocumentFaild = false;
  isFileDeleted: boolean = false;
  userStateError: string = null;
  emailSendAgain: boolean = false;
  emailSending: boolean = false;
  invalidEmail: boolean = false;



  stepperGo(index: number) {
    this.stepper.selectedIndex = index;
  }
}

